import { Clipboard } from "@capacitor/clipboard";
import { Trans, t } from '@lingui/macro';
import { Copy, Plus, MoreVertical } from "lucide-react";
import { useState } from "react";
import { DocuBot } from "../../../models/DocuBot";
import { Message } from "../../../models/Message";
import { Room } from "../../../models/Room";
import { Soribot, SoribotSimplified } from "../../../models/Soribot";
import { Fire } from "../../../services/FireClient";
import { My } from "../../../services/My";
import { ChatMessage } from "./BotDocuPrivateModal";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../../components/ui/popover";
import { Button } from "../../../components/ui/button";
import { useToast } from "../../../hooks/use-toast";


export const BotAskModalPopover: React.FC<{ bot: DocuBot | Soribot | SoribotSimplified, msg: ChatMessage, room: Room | null }> = ({ bot, msg, room }) => {
  const [open, setOpen] = useState(false);
  const { toast } = useToast();
  const answer = msg.answer?.split('Sources:')[0];

  if (msg.inProgress) return null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="h-6 w-6 text-gray-400 hover:text-gray-900">
          <MoreVertical className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-48 p-0" align="end">
        <div className="flex flex-col">
          <Button variant="ghost" className="justify-start rounded-none h-10 px-4 font-normal" onClick={copyToClipboard}>
            <Copy className="mr-2 h-4 w-4" />
            <Trans>Copy to clipboard</Trans>
          </Button>
          {room && (
            <Button variant="ghost" className="justify-start rounded-none h-10 px-4 font-normal" onClick={addToRoom}>
              <Plus className="mr-2 h-4 w-4" />
              <Trans>Post to room</Trans>
            </Button>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );

  async function copyToClipboard() {
    await Clipboard.write({ string: `@${bot.name}, ${msg.prompt}\n\n${bot.name}:\n${answer}` });
    setOpen(false);
    toast({
      title: t`Copied`,
      description: t`Copied to clipboard`,
      duration: 1500,
    });
  }

  async function addToRoom() {
    if (!room) return;
    const msgUser = new Message(room, My.user);
    msgUser.text = `@${bot.name}, ${msg.prompt}\n\n${bot.name}:\n${answer}`;

    toast({
      title: t`Notice`,
      description: t`Posting answer to #${room.name} as a message without notifying others.`,
      duration: 2000
    });

    setOpen(false);
    Fire.msg.saveMessage(msgUser);
  }
}